import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { full } from "./shared/routes/full.routes";
import { content } from "./shared/routes/routes";
import { LoginComponent } from "./auth/login/login.component";
import { AuthGuard } from "./shared/guards/auth.guard";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { ForgotMailComponent } from "./auth/forgot-mail/forgot-mail.component";
import { RegisterComponent } from "./auth/register/register.component";
import { ChangePasswordComponent } from "./auth/change-password/change-password.component";
import { ConfirmarTurnosComponent } from "./confirmar-turnos/confirmar-turnos.component";
import { EstudiosComponent } from "./estudios/estudios.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'menu/mis-turnos',
    pathMatch: 'full'
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "change-password/:doc",
    component: ChangePasswordComponent,
  },
  {
    path: "forgot-mail",
    component: ForgotMailComponent,
  },
  {
    path: "register",
    component: RegisterComponent,
  },
  {
    path: "confirmar-turno/:idTurno",
    component: ConfirmarTurnosComponent,
  },
  {
    path: 'estudios/token/:token',
    component: EstudiosComponent,
  },
  {
    path: "",
    component: ContentComponent,
    canActivate: [AuthGuard],
    children: content
  },
  {
    path: "",
    component: FullComponent,
    canActivate: [AuthGuard],
    children: full
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [
    [
      RouterModule.forRoot(routes, {
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
    ],
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
